import React from "react";
import { Helmet } from "react-helmet-async";
import MarketingLayout from "./components/MarketingLayout";
import ModuleHero from "./sections/module/ModuleHero";
import ModuleFeatures from "./sections/module/ModuleFeatures";
import ModuleUseCases from "./sections/module/ModuleUseCases";
import ModuleFaq from "./sections/module/ModuleFaq";
import ModulePricingSummary from "./components/ModulePricingSummary";
import { MODULE_CONFIG, modulePath } from "./data/modules";

const ModuleShowcasePage = ({ moduleKey }) => {
  const config = MODULE_CONFIG[moduleKey];

  if (!config) {
    return (
      <MarketingLayout showFinalCta={false}>
        <section className="mk-section">
          <div className="mk-wrap">
            <h2>Module introuvable</h2>
            <p>Le module demandé n'existe pas. <a href="/">Retour à l'accueil</a>.</p>
          </div>
        </section>
      </MarketingLayout>
    );
  }

  return (
    <MarketingLayout>
      <Helmet>
        <title>{`${config.label} - ASAP Hub`}</title>
        <meta name="description" content={config.hero.lead} />
        <link rel="canonical" href={`https://www.asap-hub.ai${modulePath(moduleKey)}`} />
        <meta property="og:title" content={`${config.label} - ASAP Hub`} />
        <meta property="og:description" content={config.hero.lead} />
      </Helmet>
      <ModuleHero
        moduleKey={moduleKey}
        label={config.label}
        hero={config.hero}
        screenshot={config.showcase}
      />
      <ModuleFeatures features={config.features} />
      <ModuleUseCases useCases={config.useCases} />
      <ModulePricingSummary moduleKey={moduleKey} />
      <ModuleFaq faq={config.faq} label={config.label} />
    </MarketingLayout>
  );
};

export default ModuleShowcasePage;
